<script>
    export let showTip = false;
    export let message = "";
    export let autoDismissTime = 10000; // Default: 10000ms = 10s

    const dismissTip = () => {
        showTip = false;
        localStorage.setItem('tipShown', 'true');
    };

    // Auto dismiss after `autoDismissTime` milliseconds
    $: if (showTip) {
        setTimeout(() => {
            dismissTip();
        }, autoDismissTime);
    }
</script>

{#if showTip}
<div class="absolute bg-blue-200 p-2 rounded-md text-blue-700 shadow-lg flex items-start justify-between" style="margin-top: -120px; margin-left: 43px;">
    <div class="max-w-md">
        {message}
    </div>
    <button 
        class="ml-2 text-sm py-1 px-2 text-blue-700 rounded" 
        on:click={dismissTip}>
        <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="20" width="20" xmlns="http://www.w3.org/2000/svg"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
    </button>
</div>

{/if}
